import { FC } from 'react';
import classNames from 'classnames';

import { Body, Bold } from '@rikstv/shared-components';

import './ErrorMessage.scss';

interface Props {
  leftAligned?: boolean;
  title?: string | boolean | undefined;
  message?: string | JSX.Element;
  show: boolean;
}

export const ErrorMessage: FC<Props> = ({ title, message = 'Vennligst prøv igjen', leftAligned, show }) => {
  const errorTitle = title !== undefined ? title : 'Noe gikk galt';
  const hasTitle = title !== false;

  if (!show) {
    return null;
  }

  return (
    <div className={classNames('error', { error__left: leftAligned, error__nomargin: !hasTitle })}>
      {hasTitle && <Bold className="error__title">{errorTitle}</Bold>}
      <Body>{message}</Body>
    </div>
  );
};
